import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class PagesProject {

	static init() {

		this.projectCardReveal();

		// let filters = document.querySelectorAll('.projects-sidebar-filters a');
		// let projects = document.querySelectorAll('.column-projects');
		//
		// filters.forEach( (filter) => {
		// 	filter.addEventListener( "click", (e) => {
		// 		e.preventDefault();
		//
		// 		if( filter.classList.contains('current') ){
		//
		// 			projects.forEach( (item) => {
		// 				item.classList.remove('hidden');
		// 			});
		// 			filters.forEach( (filter) => {
		// 				filter.classList.remove('current');
		// 			});
		//
		// 		}else{
		//
		// 			let category = filter.dataset.filter;
		// 			projects.forEach( (item) => {
		// 				let categories = item.dataset.category.split(',');
		// 				item.classList.toggle('hidden', !categories.includes(category));
		// 			});
		// 			filters.forEach( (filter) => {
		// 				filter.classList.remove('current');
		// 			});
		// 			filter.classList.add('current');
		//
		// 		}
		//
		// 		let counter = document.querySelector('.project-count');
		// 		let count = document.querySelectorAll('.column-projects:not(.hidden)');
		// 		counter.innerHTML = count.length;
		// 		ScrollTrigger.refresh();
		//
		// 	});
		// });

	}

	static projectCardReveal(){

		ScrollTrigger.batch(".projects-card .projects-card-image", {
			onEnter: elements => {
				gsap.to(elements, {
					'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
					stagger: 0.15
				});
			},
			start: "top 85%",
			once: true
		});

	}

}
